import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const updateOffers = async (body) => {
  try {
    const response = await axiosInstance.post('/offers/update/', body);
    return response.data;
  } catch (error) {
    console.error('Update Offers API error:', error);
    throw error;
  }
};

export const useUpdateOffers = (options = {}) => {
  const queryClient = useQueryClient();
  const {
    onSuccess: externalOnSuccess,
    onError: externalOnError,
    ...mutationOptions
  } = options;

  const mutation = useMutation({
    ...mutationOptions,
    mutationFn: updateOffers,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['mpOffers'] });
      queryClient.invalidateQueries({ queryKey: ['mpOffersUpdatePreview'] });

      externalOnSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      externalOnError?.(error, variables);
    },
  });

  return {
    updateOffers: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
